import { createFileRoute } from "@tanstack/react-router";
import { Camera } from "lucide-react";
import { PageHeader } from "@/components/page-header";
import { StatusBadge } from "@/components/status-badge";
import { NewShootDialog } from "@/components/forms/new-shoot-dialog";
import { shoots } from "@/mocks/data";

export const Route = createFileRoute("/shoots")({
  head: () => ({
    meta: [
      { title: "Shoots — Studio OS" },
      { name: "description", content: "Shoot planning with shot lists, timelines, and locations." },
    ],
  }),
  component: ShootsPage,
});

function ShootsPage() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader
        title="Shoots"
        description="Plan, prep, and execute every production."
        actions={<NewShootDialog />}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {shoots.map((s) => (
          <article key={s.id} className="flex flex-col gap-4 rounded-xl bg-card p-5 ring-1 ring-border">
            <div className="flex items-start justify-between gap-3">
              <div className="flex size-10 flex-none items-center justify-center rounded-lg bg-surface-muted ring-1 ring-border">
                <Camera className="size-4 text-muted-foreground" />
              </div>
              <StatusBadge status={s.status} />
            </div>
            <div>
              <h3 className="font-medium leading-tight">{s.title}</h3>
              <p className="mt-0.5 text-sm text-muted-foreground">{s.client}</p>
            </div>
            <dl className="grid grid-cols-2 gap-2 border-t border-border pt-3 text-xs">
              <div>
                <dt className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Date</dt>
                <dd className="mt-0.5 font-medium">{s.date}</dd>
              </div>
              <div>
                <dt className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Call</dt>
                <dd className="mt-0.5 font-mono font-medium">{s.callTime}</dd>
              </div>
              <div className="col-span-2">
                <dt className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Location</dt>
                <dd className="mt-0.5">{s.location}</dd>
              </div>
            </dl>
          </article>
        ))}
      </div>
    </div>
  );
}
